import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { Button, Typography, Box } from '@mui/material';
import { RedTheme } from 'common/global';
import { TransferUniversalDashboardData } from 'TAP/redux/actions';
import { getUserAgentBrowser, getUserAgentOS } from 'TAP/utils/commonMethods';
import { DASHBOARD_DATA_ACCEPTABLE_STATUSES } from 'common/global/constants';

let redtheme = RedTheme;

export const Error = () => {
  let { instance } = useMsal();
  const dispatch = useDispatch();
  const logInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  const loggedInUserEmail =
    logInUserDetails && logInUserDetails?.user_email ? logInUserDetails?.user_email : '';
  const isUniversalDashboardDataTransfered = useSelector(
    (state) => state?.universalDashboardReducer?.isUniversalDashboardDataTransfered,
  );
  const [logoutDashboardEventRegistered, setLogoutDashboardEventRegistered] = useState(false);

  useEffect(() => {
    if (
      logoutDashboardEventRegistered &&
      DASHBOARD_DATA_ACCEPTABLE_STATUSES.includes(isUniversalDashboardDataTransfered)
    ) {
      setLogoutDashboardEventRegistered(false);
      handleLogoutUser();
    }
  }, [logoutDashboardEventRegistered, isUniversalDashboardDataTransfered]);

  const handleLogoutUser = () => {
    localStorage.clear();
    instance.logout();
  };
  const [pageExitDashboardEventRegistered, setPageExitDashboardEventRegistered] = useState(false);
  const recordPageExitEvent = () => {
    const currLogInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    setPageExitDashboardEventRegistered(true);
    dispatch(
      TransferUniversalDashboardData({
        apiType: 'page_exit',
        apiSubType: '',
        userEmailId: currLogInUserDetails?.user_email,
        pageTitle: currLogInUserDetails?.pageTitle ?? null,
        pageSubTitle: currLogInUserDetails?.pageSubTitle ?? null,
        pageURL: window.location.href,
        appName: process.env.REACT_APP_NAME,
        targetUrl: 'pagevisit/entry',
        ipAddress: null,
        idSession: currLogInUserDetails?.idSession ?? null,
        browser: getUserAgentBrowser(),
        os: getUserAgentOS(),
        visitStartTime: currLogInUserDetails?.visitStartTime ?? null,
        visitEndTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
        id: currLogInUserDetails?.id ?? null,
      }),
    );
  };
  useEffect(() => {
    if (
      pageExitDashboardEventRegistered &&
      DASHBOARD_DATA_ACCEPTABLE_STATUSES.includes(isUniversalDashboardDataTransfered)
    ) {
      setPageExitDashboardEventRegistered(false);
      recordLogoutEvent();
    }
  }, [pageExitDashboardEventRegistered, isUniversalDashboardDataTransfered]);
  const recordLogoutEvent = () => {
    setLogoutDashboardEventRegistered(true);
    dispatch(
      TransferUniversalDashboardData({
        apiType: 'user_session_logout_error',
        apiSubType: '',
        userEmailId: loggedInUserEmail,
        appName: process.env.REACT_APP_NAME,
        targetUrl: 'session',
        startDateTime: logInUserDetails?.loggedInTime,
        endDateTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
        ipAddress: null,
        idSession: logInUserDetails?.idSession ?? null,
        browser: getUserAgentBrowser(),
        os: getUserAgentOS(),
      }),
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        // set background color
        backgroundColor: redtheme.palette.box.light_gray,
      }}
    >
      <Typography variant='h1' sx={{ fontWeight: 'bold', fontSize: '3rem', mb: 3 }}>
        Unexpected Error
      </Typography>
      <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 3 }}>
        Sorry for the inconvenience
      </Typography>
      <p>
        {' '}
        Please try refreshing this page. If the problem persists, please close your browser and
        re-load, or you can logout the application also.
      </p>
      <Button
        onClick={recordPageExitEvent}
        sx={{
          color: redtheme.palette.button.black,
          // set background color
          bgcolor: redtheme.palette.button.white,
          // increase font size
          fontSize: '20px',
          // increase line height
          lineHeight: '24px',
          textTransform: 'capitalize',
          fontWeight: 800,
          fontFamily: '"J&J CircularTT Bold Web"',
          '&:hover': { backgroundColor: redtheme.palette.button.white, boxShadow: '' },
          // add margin-top
          mt: 3,
          // increase horizontal padding
          px: 4,
          // increase vertical padding
          py: 2,
        }}
        color='primary'
        variant='contained'
      >
        Logout
      </Button>
    </Box>
  );
};
